var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18C20 18.5523 19.5523 19 19 19C18.4477 19 18 18.5523 18 18C18 17.4477 18.4477 17 19 17C19.5523 17 20 17.4477 20 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18C9 17.4477 9.44772 17 10 17C10.5523 17 11 17.4477 11 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C2.89543 5 2 5.89543 2 7V16C2 16.9322 2.63777 17.7154 3.50078 17.9372C3.53411 16.5855 4.64029 15.5 6 15.5C6.8178 15.5 7.54389 15.8927 8 16.4998C8.45611 15.8927 9.1822 15.5 10 15.5C11.3807 15.5 12.5 16.6193 12.5 18H16.5C16.5 16.6193 17.6193 15.5 19 15.5C20.1741 15.5 21.1592 16.3094 21.4277 17.4006C21.7817 17.0398 22 16.5454 22 16V12.75H17V11.25H21.625L20.0528 8.10557C19.714 7.428 19.0215 7 18.2639 7H17C17 5.89543 16.1046 5 15 5H4ZM5.5 8.25C5.91421 8.25 6.25 8.58579 6.25 9V13C6.25 13.4142 5.91421 13.75 5.5 13.75C5.08579 13.75 4.75 13.4142 4.75 13V9C4.75 8.58579 5.08579 8.25 5.5 8.25ZM9.5 8.25C9.91421 8.25 10.25 8.58579 10.25 9V13C10.25 13.4142 9.91421 13.75 9.5 13.75C9.08579 13.75 8.75 13.4142 8.75 13V9C8.75 8.58579 9.08579 8.25 9.5 8.25ZM13.5 8.25C13.9142 8.25 14.25 8.58579 14.25 9V13C14.25 13.4142 13.9142 13.75 13.5 13.75C13.0858 13.75 12.75 13.4142 12.75 13V9C12.75 8.58579 13.0858 8.25 13.5 8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.e27c7210caa6889aebc30e603a287210.svg";
export { ForwardRef as ReactComponent };